import request from "@/config/utils/request";

// 编辑
export function postEditPcConcSub(data) {
  return request({
    url: "/apis/demo/pcconcsub/editPcConcSub",
    method: "POST",
    data
  });
}
// 添加
export function postAddPcConcSub(data) {
  return request({
    url: "/apis/demo/pcconcsub/savePcConcSub",
    method: "POST",
    data
  });
}
// 删除
export function postDeletePcConcSub(data) {
  return request({
    url: "/apis/demo/pcconcsub/removePcConcSub", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function postGetDetail(data) {
  return request({
    url: "/apis/demo/pcconcsub/getPcConcSubById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function postGetList(data) {
  return request({
    url: "/apis/demo/pcconcsub/listPcConcSubPage",
    method: "POST",
    data
  });
}
